export enum PermissionName {
  CreateRootOrganization = "create_root_org",
  CreateChildOrganization = "create_child_org",
  UpdateOrganization = "update_org",
  DeleteOrganization = "delete_org",
  UpdateChildOrganization = "update_child_org",
  DeleteChildOrganization = "delete_child_org",
  AssignRoles = "assign_roles",
  AllocateSystemCredits = "allocate_system_credits",
  TransferOrganizationCredits = "transfer_org_credits",
  ManageUsers = "manage_users",
  ViewAuditLogs = "view_audit_logs",
  ManageOrganizationLicense = "manage_org_license",
  ManageOrganizationIntegration = "manage_org_integration",
  SendAdoptionRequest = "send_adoption_request",
  ProcessAdoptionRequest = "process_adoption_request",
  ViewAdoptionRequests = "view_adoption_requests"

}

export interface IPermission {
  name: PermissionName;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  translation_key: string;
}

export enum Role {
  SystemAdmin = "system_admin",
  OrganizationOwner = "organization_owner",
  OrganizationAdmin = "organization_admin",
  Teacher = "user"
}
export interface IRole {
  name: Role;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  translation_key: string;
}

export interface IOrgPermissionsAndRole {
  organizationId: string | null;
  permissions: IPermission[];
  role: IRole | null;
}